import React from 'react'

const Governments = ({name, neighbourhoods, findSelectedPlaceNeighborhoods}) => 
    <li onClick={() => findSelectedPlaceNeighborhoods(neighbourhoods, name)}>{name}</li>

export default Governments